import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';
import { DeviceService } from 'src/app/Core/services/devices.service';
import { flattenJSON } from 'src/app/Core/utils/flattenJSON';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import { ToasterService } from 'src/app/Core/services/toaster.service';
import { string } from 'prop-types';
import { DeviceType, getDeviceType } from 'src/app/Core/utils/deviceUtils';

const commonDeviceConfiguration: { [key: string]: string } = {
  alarm_interval: "Alarm Interval",
  amp_rate: "Amp Rate",
  detector_model: "Detector Model",
  alerts: "Alert",
  alarm_reset_time: "Alarm Reset Time",
  announcement: "Room Type",
  aprssi: "Signal Strength (AP RSSI)",
  battery_level: "Battery Level",
  battery: "Battery Status",
  battery_voltage: "Battery Voltage",
  batt_volt: "Battery Voltage",
  co2: "CO2",
  co2_status: "CO2 Status",
  coalarm: "CO Alarm",
  co_alarm: "CO Alarm",
  colevel: "CO Level",
  co_level: "CO Level",
  checkin_interval: "Check-in Interval",
  end_of_life_alarm: "End of Life Alarm",
  fwmb: "Alarm Version",
  fw_mb: "Alarm Version",
  fw_alarm: "Alarm Version",
  "fwrev-alarm": "Alarm Version",
  "fwrev-net": "Net Version",
  "fwrev-wm": "Firmware Version",
  fwmm: "Firmware Version",
  fw_wm: "Firmware Version",
  fwnet: "Net Version",
  fw_net: "Net Version",
  fw_upgrade: "FW Upgrade",
  g_res: "G Resistant",
  hardwire_co: "Hardwire Interconnected CO",
  hardwire_smoke: "Hardwire Interconnected Smoke",
  heartbeat_host: "Heartbeat Host",
  heartbeat_period: "Heartbeat Period",
  humidity_status: "Humidity Status",
  hold_alarm_time: "Hold Alarm Time",
  hpa: "HPA",
  hpa_status: "HPA Status",
  humidity: "Humidity(RH%)",
  hw_rev: "Hardware Revision",
  hwrev: "Hardware Revision",
  iaq: "IAQ",
  iaq_accuracy: "IAQ Accuracy",
  iaq_interval: "IAQ Interval",
  iaq_frequency: "IAQ Frequency",
  iaq_last_test_time: "IAQ Last Test Time",
  iaq_learn_cntdown: "IAQ Learn Countdown",
  iaq_state: "IAQ State",
  iaq_status: "IAQ Status",
  iaq_temp: "IAQ Temp",
  iaq_temp_status: "IAQ Temperature Status",
  iaq_test_status: "IAQ Test Status",
  id: "Device ID",
  instance_id: "Instance ID",
  label: "Device Name",
  lastseen: "Last Seen",
  last_test_time: "Last Test Time",
  life: "Life(Weeks before EOL)",
  "location-id": "Location ID",
  "location-label": "Property Name",
  location_id: "Location ID",
  locate_active: "Locate Active",
  lost_timeout: "Lost Timeout",
  low_temp_alarm: "Low Temp Alarm",
  lowbattery_alarm: "Low Battery Alarm",
  low_battery_alarm: "Low Battery Alarm",
  model: "Model",
  notify: "Notify",
  notify_contact: "Notify Contact",
  notify_eol: "Notify EOL",
  notify_iaq_temp: "Notify IAQ Temp",
  notify_tvoc: "Notify TVOC",
  notify_mold_risk:"Notify Mold Risk",
  notify_humidity:"Notify Humidity",
  ota: "OTA",
  overall_iaq_status: "Overall IAQ Status",
  parent: "Parent",
  parent_id: "Parent ID",
  ptt_active: "PTT Active",
  ptt_state: "PTT State",
  peak_co_level: "Peak CO Level",
  rapid_tempvariation_status: "Rapid Tempvariation Status",
  reset_flag: "Reset Flag",
  serialnumber: "Serial Number",
  ssid: "SSID(Wi-Fi NW name)",
  status: "Status",
  temperature_ad: "Temperature ad",
  temperature_c: "Temperature c",
  tempvariation_value: "Tempvariation Value",
  toomuch_smoke: "Too Much Smoke",
  tvoc: "TVOC Level",
  tvoc_status: "TVOC Status",
  water_alarm: "Water Alarm",
  smoke_alarm: "Smoke Alarm",
  smoke_comp: "Smoke Comp",
  smoke_hushed: "Smoke Hushed",
  smoke_level: "Smoke Level",
  vent_status: "Vent Status",
};
@Component({
  selector: 'app-device-detail-ctl',
  templateUrl: './device-detail-ctl.component.html',
  styleUrls: ['./device-detail-ctl.component.css'],
  providers: [DatePipe]
})
export class DeviceDetailCtlComponent implements OnInit {
  deviceID: string | undefined;
  device: any;
  deviceModel!: string | '';
  deviceSerialnumber: string | undefined;
  deviceLastseen:string | undefined;
  deviceLabel:string = '';
  deviceBatterylevel:string | undefined;
  deviceLocationID: string | undefined ;
  deviceLastTestTime:string | undefined;
  public tableHeaders: string[] = [];
  flattenedData: { [key: string]: any } = {};
  deviceInfoToggle:boolean = true;
  deviceDetailToggle:boolean = true;
  status: string;
  roomType: string;
  alarmVersion: any;
  netVersion: any;
  firmwareVersion: any;
  deviceType: DeviceType = DeviceType.Unknown;
  propertyName: string;
  showAllParameters: boolean = false;
  offline: boolean;
  contactLost: boolean;
  boldFontParameters: string[] = [
  'Signal Strength (AP RSSI)',
  'Battery Status',
  'Battery Voltage',
  'CO Alarm',
  'CO Level',
  'Hardwire Interconnected CO',
  'Smoke Alarm',
  'Too Much Smoke',
  'Smoke Hushed',
  'Hardwire Interconnected smoke',
  'Humidity(RH%)',
  'Humidity Status',
  'Hardware Revision',
  'Last Test Time',
  'Life(Weeks before EOL)',
  'Notify Contact',
  'Notify Humidity',
  'Notify Mold Risk',
  'OTA',
  'Serial Number',
  'Smoke Level',
  'Temperature',
  'TVOC',
  'Label',
  'Last Seen',
  'Notify',
  'Notify EOL',
  'Notify IAQ Temp',
  'Notify TVOC',
  'PTT State',
  'Model',
  'Device model',
  'Inspection date',
  'Manufacturing date',
  'Expiry date',
  'Battery state',
  'Ap rssi',
  'Battery Level',
  'TVOC Level',
  'TVOC Status',
  'SSID(Wi-Fi NW name)',
  'Water Alarm',
  'Low Battery Alarm',
  'Low Temp Alarm',
  'Offline',
  'Serial number'
];

tooltipMap: { [key: string]: string } = {
  'SSID(Wi-Fi NW name)': 'Available in App Advanced Details page',
  'Serial Number': 'Available in App Advanced Details page',
  'Alarm Version': 'Available in App Advanced Details page',
  'Firmware Version': 'Available in App Advanced Details page',
  'Net Version': 'Available in App Advanced Details page',
  'Device Name': 'Available in App Device Dashboard page',
  'Room Type': 'Available in App Device Dashboard page',
  'Battery Level': 'Available in App Device Dashboard page',
  'Notify EOL': 'Available in App Device settings page (Device Alerts)',
  'Notify IAQ Temp': 'Available in App Device settings page (Indoor Air Quality Alerts)',
  'Notify Humidity': 'Available in App Device settings page (Indoor Air Quality Alerts)',
  'Notify TVOC': 'Available in App Device settings page (Indoor Air Quality Alerts)',
  'Life(Weeks before EOL)': 'Available in App Device Dashboard page',
  'contactLost':'Cloud connectivity status',
  'CO Alarm': 'Available in App Device Dashboard page',
  'Smoke Alarm': 'Available in App Device Dashboard page',
  'Serial number': 'Available in App Advanced Details page',
  'Water Alarm': 'Available in App Device Dashboard page',
  'Low Temp Alarm': 'Available in App Device Dashboard page',
  'Inspection date': 'Available in App Device Dashboard page',
  'Manufacturing date': 'Available in App Device Dashboard page',
  'Expiry date': 'Available in App Device Dashboard page',
  'Device model': 'Available in App Device Dashboard page'
};

  constructor(private http: HttpClient, private route: ActivatedRoute, private deviceService : DeviceService, private datePipe: DatePipe, private toaster: ToasterService) {
  
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.deviceID = params.get('id') || '';
      this.deviceLocationID = params.get('locationId') || '';
      this.fetchUserData();
    });
  }

  fetchUserData() {
    if (this.deviceID && this.deviceLocationID) {
      this.deviceService.getDeviceDataWithLocation(this.deviceID, this.deviceLocationID).subscribe({
        next: (data: any) => {
          const dateProperties = ['last_test_time', 'lastseen', 'iaq_last_test_time', 'last_seen'];
          dateProperties.forEach((property) => {
            if (data.hasOwnProperty(property)) {
              data[property] = this.datePipe.transform(data[property], 'long');
            }
          });

          this.flattenedData = flattenJSON(data);
          if (this.flattenedData.hasOwnProperty('location_id')) {
            delete this.flattenedData['location_id'];
          }

          this.deviceType = getDeviceType(data);
          this.handleInvalidDeviceParams();

          const model = data.model;
          this.deviceModel = model;
          const config = commonDeviceConfiguration[model] || {};

          this.flattenedData = Object.keys(this.flattenedData).reduce<{ [key: string]: any }>((acc, key) => {
            const displayKey = key in commonDeviceConfiguration ? commonDeviceConfiguration[key] : this.capitalizeFirstLetter(key);
            acc[displayKey] = this.flattenedData[key];
            return acc;
          }, {});

          this.deviceSerialnumber = data.serialnumber ?? data.serial_number;
          this.deviceLastseen = data.lastseen ?? data.last_seen;
          this.deviceLabel = data.label;
          this.deviceBatterylevel = data.battery_level;
          this.deviceLocationID = data.location_id;
          this.deviceLastTestTime = data.last_test_time;
          this.tableHeaders = Object.keys(this.flattenedData);

          this.roomType = data.announcement;
          this.alarmVersion = data.fwmb || data.fw_alarm || data?.fwrev?.alarm || data.fw_mb;
          this.netVersion = data.fwnet || data.fw_net || data?.fwrev?.net;
          this.firmwareVersion = data.fwmm || data.fw_wm || data?.fwrev?.wm;
          this.propertyName = data?.location?.label;

          this.contactLost = !!data.contact_lost;
          this.status = this.getDeviceStatus(this.contactLost);
          this.offline = !!data.offline;
        },

        error: (error) => {
          console.error('Error fetching user data:', error);
          if (error.status === 404) {
            this.toaster.openDialogBox("This device is no longer available.", true);
          }
        }
      });
    }
  }
  
  getDeviceStatus(contactLost: boolean): string {
    return contactLost ? 'INACTIVE' : 'ACTIVE';
  }

  toggleShowAllParameters() {
    this.showAllParameters = !this.showAllParameters;
  }
  
  capitalizeFirstLetter(str: string | null | undefined): string {
    if (!str) {
      return '';
    }
    const capitalizedStr = str.charAt(0).toUpperCase() + str.slice(1);
    return capitalizedStr.replace(/_/g, ' ');
  }

  displayValue(value: any): string {
    if (value === '' || value === null || value === undefined) {
      return 'NA';
    }
    if (typeof value === 'string') {
      if (value === '' || value === null || value === undefined) {
        value = 'NA';
      }

      return this.capitalizeFirstLetter(value);
    }

    if (typeof value === 'boolean') {
      if (value === undefined || value === null) {
        value = '';
      }else {
        value = value ? 'True' : 'False';
      }
    }

    return value.toString();
  }

  displayValueOffline(value: boolean | null | undefined): string {
    if (value === null || value === undefined) {
      return '';
    }
    return value ? 'True' : 'False';
  }

  isSmartFxDevice(): boolean {
    return this.flattenedData["Model"] === "smartfx"
  }
  
  filterKeys(keys: string[]) {
    keys.forEach(key => {
      if (key in this.flattenedData) {
        delete this.flattenedData[key];
      }
    });
  }

  handleInvalidDeviceParams() {
    const coParams = ['co_alarm', 'co_level', 'hardwire_co', 'co_conserve', 'flt_co', 'co_acc', 'co_ppm', 'co2', 'co2_status', 'colevel', 'coalarm'];
    const smokeParams = ['smoke_alarm', 'smoke_level', 'smoke_comp', 'too_much_smoke', 'smoke_hushed', 'hardwire_smoke', 'mobile_smoke_hushed'];
    const iaqParams = ['notify_iaq_temp', 'iaq_temp', 'iaq_temp_status', 'iaq', 'iaq_status', 'iaq_state', 'iaq_learn_cntdown', 'iaq_last_test_time', 'iaq_test_status', 'iaq_frequency', 'overall_iaq_status', 'notify_mold_risk', 'notify_tvoc', 'notify_humidity', 'humidity', 'hpa', 'hpa_status', 'tvoc', 'tvoc_status', 'temperature', 'iaq_learn_countdown'];
    switch (this.deviceType) {
      case DeviceType.RevA:
      case DeviceType.RevB:
        this.filterKeys(smokeParams);
        this.filterKeys(coParams);
        this.filterKeys(iaqParams);
        break;
      case DeviceType.SmokeOnly:
      case DeviceType.OrchidSmoke:
        this.filterKeys(coParams);
        this.filterKeys(iaqParams);
        break;
      case DeviceType.SmokeCOBLE:
      case DeviceType.SmokeCOTI:
      case DeviceType.OrchidSmokeCo:
        this.filterKeys(iaqParams);
        break;

      case DeviceType.COIAQApollo:
      case DeviceType.AthenaCOIAQ:
        this.filterKeys(smokeParams);
        break;

      case DeviceType.SmokeIAQOnly:
        this.filterKeys(coParams);
        break;

      case DeviceType.SmokeCOIAQ:
        break;

      case DeviceType.AthenaCO:
        this.filterKeys(smokeParams);
        this.filterKeys(iaqParams);
        break

      case DeviceType.SmartFx:
        this.filterKeys(smokeParams);
        this.filterKeys(coParams);
        this.filterKeys(iaqParams);
        break;

      default:
        break;
    }
  }

  getLastActiveLabel(): string {
    if (this.deviceLastseen) {
        return 'Last Seen';
    } else if (this.deviceLastTestTime) {
        return 'Last Test Time';
    } else {
        return 'Last Seen'; 
    }
}

getLastActiveValue(): string {
    if (this.deviceLastseen) {
        return this.deviceLastseen
    } else if (this.deviceLastTestTime) {
        return this.deviceLastTestTime
    } else {
        return 'NA';
    }
}

getTooltip(key: string): string {
  return this.tooltipMap[key] || '';
}

getSignalStrengthClass(value: any): { class: string, tooltip: string } {
    if (typeof value === 'string') {
        value = parseInt(value, 10);
    }

    if (value <= -100) {
        return { class: 'signal-poor', tooltip: 'Poor signal strength' };
    } else if (value <= -86) {
        return { class: 'signal-fair', tooltip: 'Fair signal strength' };
    } else if (value <= -70) {
        return { class: 'signal-good', tooltip: 'Good signal strength' };
    } else {
        return { class: 'signal-excellent', tooltip: 'Excellent signal strength' };
    }
  }
}

